(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initializeProductListSection = (section) => {
      if (!section || section.dataset.productListAnimated === 'true') return;

      const items = section.querySelectorAll('.resource-list__item');
      if (!items.length) return;

      section.dataset.productListAnimated = 'true';

      items.forEach((item, index) => {
        item.style.setProperty('--product-list-animation-delay', `${index * 0.08}s`);
      });

      // Auto-center products when there are fewer items than columns
      const gridContainer = section.querySelector('.resource-list--grid');
      if (gridContainer) {
        const columnsValue = section.dataset.columns || section.querySelector('[data-columns]')?.dataset?.columns;
        const columns = parseInt(columnsValue) || 4;
        const productCount = items.length;

        if (productCount < columns) {
          gridContainer.classList.add('auto-center-items');
        } else {
          gridContainer.classList.remove('auto-center-items');
        }
      }

      if (reducedMotionQuery.matches) {
        section.classList.add('section-resource-list--in-view');
        return;
      }

      const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          section.classList.add('section-resource-list--in-view');
          observerInstance.unobserve(entry.target);
        });
      }, { threshold: 0.2 });

      observer.observe(section);
    };

    document.querySelectorAll('[data-section-type="product-list"]').forEach(initializeProductListSection);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target?.querySelector('[data-section-type="product-list"]');
      if (section) {
        // Allow re-initialization if the section is re-rendered
        section.dataset.productListAnimated = 'false';
        initializeProductListSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
